import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import React, { Fragment } from 'react';
import Auth from 'stores/Auth';
import styles from './styles';
import {
	Button,
	Checkbox,
	Container,
	Dimmer,
	Divider,
	Form,
	Header,
	Loader,
	Segment,
	Modal
} from 'semantic-ui-react';
import ConsentSignature from 'stores/ui/manager/ConsentSignature';
import MessageBox from 'components/MessageBox';
import MsgStore from 'stores/MsgStore';
import UiShared from 'stores/UiShared';
import { observable } from 'mobx/lib/mobx';
const TERMS = 'terms and conditions';
const PRIVACY_POLICY = 'privacy policy';

@withRouter
@inject(rootStore => ({
	auth: rootStore.auth,
	consentSignature: rootStore.ui.manager.consentSignature,
	uiShared: rootStore.uiShared
}))
@observer
export default class Consent extends React.Component {
	props: {
		auth?: Auth,
		history?: History,
		consentSignature?: ConsentSignature,
		onRequestClose: () => {},
		uiShared?: UiShared
	};

	static defaultProps = {
		isOpen: false
	};

	msgStore = new MsgStore();

	@observable saving: boolean = false;

	handleAgree = async () => {
		try {
			this.msgStore.clear();
			this.saving = true;
			await this.props.consentSignature.signAllConsents();
			this.handleClose();
		} catch (err) {
			this.msgStore.setError(err.toString());
		} finally {
			this.saving = false;
		}
	};

	handleClose = (logout = false) => {
		this.resetForm();
		this.props.onRequestClose(logout);
	};

	resetForm = () => {
		this.msgStore.clear();
	};

	redirectTo = val => {
		const screen = val?.toLowerCase();
		const { uiShared, history, auth } = this.props;
		const role = auth.user.role;
		let redirTo;
		switch (screen) {
			case TERMS:
				redirTo = 'terms';
				break;
			case PRIVACY_POLICY:
				redirTo = 'privacy';
				break;
		}
		if (!redirTo) return;
		uiShared.hideModal();
		history.push(`/app/${role}/${redirTo}`);
	};

	render() {
		const { auth, consentSignature, isOpen, history } = this.props;
		const { saving } = this;
		const { items } = consentSignature;

		return (
			<Fragment>
				<Modal open={isOpen} size="small" closeOnDimmerClick={false}>
					<Fragment>
						<Dimmer active={saving} inverted>
							<Loader content="Saving..." />
						</Dimmer>
						<Modal.Content>
							<Segment basic>
								<Container>
									<p style={{ marginBottom: '25px' }}>Please agree to the below.</p>

									<p>I, {auth.user.fullName}, agree and consent to:</p>
									<Form>
										<MessageBox msgStore={this.msgStore} />
										{items.map((el: Consent, idx: number) => (
											<Form.Field key={idx} className={styles.consent_wrapper}>
												<Checkbox
													className={styles.consent_check_box}
													checked={el.confirmed}
													onChange={() => (el.confirmed = !el.confirmed)}
												/>

												{[TERMS, PRIVACY_POLICY].includes(el.text?.toLowerCase()) ? (
													<div
														className={styles.consent_label_lnk}
														dangerouslySetInnerHTML={{ __html: el.text }}
														onClick={() => {
															this.redirectTo(el.text);
														}}
													/>
												) : (
													<div
														className={styles.consent_label}
														dangerouslySetInnerHTML={{ __html: el.text }}
													/>
												)}
											</Form.Field>
										))}
										<div className={styles.buttonsRow}>
											<Button
												onClick={() => {
													this.handleClose(true);
												}}
											>
												Cancel
											</Button>
											<Button
												primary
												disabled={!items?.every(el => el.confirmed)}
												onClick={() => {
													this.handleAgree();
												}}
											>
												I agree
											</Button>
										</div>
									</Form>
								</Container>
							</Segment>
						</Modal.Content>
					</Fragment>
				</Modal>
			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Consent/index.js